import "./ErrorModal.css";
import { IoCloseOutline } from "react-icons/io5";
import React from "react";

const ErrorModal = ({ handleOK, errorMessage, setErrorMessage, setErrorModal, actionButtonTitle = "OK" }) => {
  return (
    <div className="error-modal">
      <div className="modal-fixed">
        <div
          className="close"
          onClick={() => {
            setErrorModal((pre) => !pre);
            setErrorMessage("");
          }}
        >
          <IoCloseOutline />
        </div>
        <div className="content">
          <div
            className="data my-4"
            dangerouslySetInnerHTML={{
              __html: errorMessage,
            }}
          ></div>

          <div className="d-flex justify-content-end gap-3 mt-3">
            <button
              className="button"
              onClick={() => {
                setErrorModal(false);
                setErrorMessage("");
                handleOK?.();
              }}
            >
              {actionButtonTitle}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default ErrorModal;
